import {combineReducers} from "redux";
import {loadingBarReducer} from "react-redux-loading";
import currentUser from './SetUser';

export default combineReducers({
    currentUser,
    loadingBar:loadingBarReducer
})
